// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconNewFile = createRemixIcon('IconNewFile', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.25 0H2v24h20V5.732l-.366-.366l-5-5L16.268 0zM4.5 21.5v-19h9v6h6v13z\" clip-rule=\"evenodd\"/>");
